import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import {
  FORGOT_PASSWORD_ROUTE,
  FORGOT_PASSWORD_SENT_ROUTE,
  INVITE_USER_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  RESET_PASSWORD_CODE_USER_ROUTE,
  FEDERATED_SIGN_IN_REDIRECT,
  FEDERATED_SIGN_IN_TRIGGER,
  REGISTER_BY_PRODUCT_ROUTE,
  SSO_EMBED_TRIGGER,
  SAGE_ID_SIGN_IN_TRIGGER,
  SAGE_50_TRIGGER,
  SFA_TRIGGER
} from '../../core/constants';
import { ForgotPasswordSubmit } from '../../forgot-password-submit/components/forgot-password-submit';
import { ForgotPassword } from '../../forgot-password/components/forgot-password';
import { FederatedSignInRedirectManager } from '../../federated-sign-in/federated-sign-in-redirect-manager';
import { FederatedSignInTrigger } from '../../federated-sign-in/federated-sign-in-trigger';
import { SSOEmbedTrigger } from '../../sso-embed/sso-embed-trigger';
import { ForgotPasswordSent } from '../../forgot-password/components/forgot-password-sent';

import { SageLogin } from '../../login/components/sage-login';
import { SageIdSignInTrigger } from '../../sage-id-sign-in/sage-id-sign-in-trigger';
import { SageRegister } from '../../register/components/sage-register';
import { SageInvite } from '../../invite/components/sage-invite';
import { Sage50Trigger } from '../../sage-50/sage-50-trigger';
import { SfaTrigger } from '../../sfa/sfa-trigger';

/**
 * Manages the routing when an user is unauthenticated.
 * @returns {JSX.Element}
 */
export const UnauthenticatedRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={LOGIN_ROUTE} element={<SageLogin />} />
      {getRegisterRoutes()}
      <Route path={RESET_PASSWORD_CODE_USER_ROUTE} element={<ForgotPasswordSubmit />} />
      <Route path={FORGOT_PASSWORD_ROUTE} element={<ForgotPassword />} />
      <Route path={FORGOT_PASSWORD_SENT_ROUTE} element={<ForgotPasswordSent />} />
      <Route path={INVITE_USER_ROUTE} element={<SageInvite />} />
      <Route path={FEDERATED_SIGN_IN_TRIGGER} element={<FederatedSignInTrigger />} />
      <Route path={SAGE_ID_SIGN_IN_TRIGGER} element={<SageIdSignInTrigger />} />
      <Route path={SFA_TRIGGER} element={<SfaTrigger />} />
      <Route path={SAGE_50_TRIGGER} element={<Sage50Trigger />} />
      <Route path={FEDERATED_SIGN_IN_REDIRECT} element={<FederatedSignInRedirectManager />} />
      <Route path={SSO_EMBED_TRIGGER} element={<SSOEmbedTrigger />} />
      <Route path="*" element={<Navigate to={LOGIN_ROUTE} replace />} />
    </Routes>
  );
};

export const getRegisterRoutes = (): React.ReactNode[] => [
  <Route key={REGISTER_ROUTE} path={REGISTER_ROUTE} element={<SageRegister />} />,
  <Route key={REGISTER_BY_PRODUCT_ROUTE} path={REGISTER_BY_PRODUCT_ROUTE} element={<SageRegister />} />
];
